/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { MatrixDependencies } from './dependenciesMatrixClass.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSparseMatrixClass } from '../../factoriesAny.js';
export var SparseMatrixDependencies = {
  MatrixDependencies: MatrixDependencies,
  equalScalarDependencies: equalScalarDependencies,
  typedDependencies: typedDependencies,
  createSparseMatrixClass: createSparseMatrixClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSparseMatrixClass.generated.js
// module id = 103
// module chunks = 0